import app from 'flarum/common/app';
import ConfirmModal from './ConfirmModal';
/**
 * Promise-based replacement for `window.confirm()`. Renders the marketplace
 * ConfirmModal and resolves true if the user clicks the confirm button,
 * false otherwise (close, cancel, escape).
 *
 *   if (!(await confirmAsync({ title: 'Excluir', message: '…' }))) return;
 */
export function confirmAsync(opts) {
  return new Promise(resolve => {
    let confirmed = false;
    app.modal.show(ConfirmModal, {
      title: opts.title,
      message: opts.message,
      confirmLabel: opts.confirmLabel,
      cancelLabel: opts.cancelLabel,
      danger: opts.danger,
      onConfirm: () => {
        confirmed = true;
        resolve(true);
      }
    });
    // When the modal closes via cancel/X/escape, ModalManager fires
    // onhide on the modal instance — fall back to a delayed resolver.
    const interval = window.setInterval(() => {
      const active = app.modal.modal;
      if (!active) {
        window.clearInterval(interval);
        if (!confirmed) resolve(false);
      }
    }, 100);
  });
}
flarum.reg.add('ramon-marketplace', 'common/components/confirmAsync', { confirmAsync: confirmAsync, });